import { combineReducers } from "redux";
import checkedProducts from "./checkedProducts";

export default combineReducers({
	checkedProducts,
});
